export default {
    path: 'gift',
    component: () => import('../Gift.vue'),
    children: [
        {
            path: '',
            name: 'Danh sách Quà tặng',
            component: () => import('../table/Table.vue')
        },
        {
            path: 'cu',
            name: 'Tạo Quà tặng',
            component: () => import('../cu/CU.vue'),
        },
        {
            path: 'cu/:id',
            name: 'Chỉnh sửa Quà tặng',
            component: () => import('../cu/CU.vue'),
        },
    ]
};